module.exports = __webpack_public_path__ + "img/gold.ed0d0fb7.png";